import { connect } from 'react-redux';
import { BASE_URL } from '../../../../variables';
import AddToCart from './AddToCartButton';
import { addToCart, removeFromCart } from '../../../../actions'
import LazyLoadImage from '../../../utils/LazyLoadImage'
const ServiceContent = ({ category, openCategoryModel, setModelText, setReplacementCartItem, services, subcategory, basicCart, addToCart, removeFromCart, incrementReplacedService, recommended}) => {

    // const updateCartReplacementItem = (service_id) => {
    //     setReplacementCartItem(service_id)
    // }
    // const opencartegoryChangeModel = () => {
    //     openCategoryModel()
    // }
    // const setModelHeaderText = (text) => {
    //     setModelText(text)
    // }
    const addToCartHandler = (service_id, setCartCount) => {
        incrementReplacedService.current = setCartCount
        // addToCart(service_id, category, opencartegoryChangeModel, setModelHeaderText, setCartCount, updateCartReplacementItem)
        addToCart(service_id, category, setCartCount, openCategoryModel, setModelText, setReplacementCartItem)
    }
    const removeFromCartHandler = (service_id) => {
        removeFromCart(service_id)
    }
    const renderCategoryItems = (itemList) => {
        return itemList.map(x => {
            return (
                <div className={`service-category-items ${recommended.data.includes(x.id) ? "recommanded" : ""}`} key={x.id}>
                    {recommended.data.includes(x.id) && (
                    <div className="recommanded-banner">
                        Recommanded
                    </div>
                    )}
                    <div className="item-detail">
                        <div className="item-image">
                            <LazyLoadImage width={60} height={60} src={BASE_URL + x.icon}/>
                            {/* <img src={BASE_URL + x.icon} alt="service" width={60}/> */}
                        </div>
                        <div className="item-main">
                            <h3>{x.name}</h3>
                            <span>&#8377;&nbsp;{x.price}</span>
                        </div>
                        <AddToCart forService={x} add={addToCartHandler} remove={removeFromCartHandler} cart={basicCart}/>
                    </div>
                    {x.description ? <div className="ui divider"></div> : ""}
                    {x.description ? <ul className="item-description-list">
                        {x.description.split('  ').map((x, i) => (
                            <li key={i}>{x}</li>
                        ))}
                    </ul> : ""}
                    
                    
                </div>
            )
        })
        
    }
    const renderServices = Reflect.ownKeys(services).map((x, i) => {
        return (
            <div id={x} className="service-items-container" key={i}>
                <div className="service-items-title">{subcategory[i]['name']}</div>
                <div className="service-items-container__main">{renderCategoryItems(services[x])}</div>
            </div>
        )
    })
    return (
        <div className="containerAF service-content-container" >  
            <div className="service-content-inner__container">
                {renderServices}
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        services: state.allServices.services,
        subcategory: state.allServices.subcategory,
        basicCart: state.basicCart
    }
}
export default connect(mapStateToProps, { addToCart, removeFromCart })(ServiceContent)